import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CenterContent from "../Components/CenterContent/CenterContent";
import InstrumentsWrrapper from "../Components/InstrumentsWrrapper/InstrumentsWrrapper";
import StudentSelects from "../Components/StudentSelects/StudentSelects";
import { observer } from "mobx-react-lite";
import { student } from "../store/student.ts";
import StudentSearchByName from "./../Components/StudentSelects/StudentSearchByName";
import DemandEduc from "../Components/Modal/DemandEduc";

export const StudentContainer = observer(function () {
  const { t, i18n } = useTranslation();
  const [active, setActive] = useState(0);
  const [demandEduc, setEducModal] = useState({
    show: false,
    id_student: 0,
  });

  useEffect(() => {
    document.onclick = hideMenu;
  }, []);

  function hideMenu() {
    const contextMenu = document.getElementById("contextMenu");
    if (contextMenu) {
      contextMenu.style.display = "none";
    }
  }

  function rightClick(e) {
    const contextMenu = document.getElementById("contextMenu");
    if (contextMenu) {
      if (contextMenu.style.display == "block") {
        hideMenu();
      } else {
        const menu = document.getElementById("contextMenu");
        menu.style.display = "block";
        menu.style.left = e.pageX + "px";
        menu.style.top = e.pageY + "px";
      }
    }
  }

  return (
    <CenterContent>
      <InstrumentsWrrapper
        leftHead={t("st:instrumentsHead.leftHead")}
        rightHead={t("st:instrumentsHead.rightHead")}
        leftChilds={<StudentSelects />}
        rightChilds={<StudentSearchByName />}
      />
      <DemandEduc
        stud={demandEduc.id_student}
        isOpen={demandEduc.show}
        setIsOpen={() => {
          setEducModal({
            show: false,
            id_student: 0,
          });
        }}
      />
      <div
        id="contextMenu"
        className="context-menu"
        style={{ display: "none" }}
      >
        <ul className="menu">
          <li className="share">
            <a
              target="_blank"
              href={`/bt/api/r/o-l?gid=${student.student.id_group}&id=${student.student.id_student}&idp=${student.student.id_protocols}&lang=${i18n.language}`} rel="noreferrer"
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.byPass")}
            </a>
          </li>
          <li className="rename">
            <a
              target="_blank"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setEducModal({
                  show: true,
                  id_student: student.student.id_student,
                });
              }}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.payEduc")}
            </a>
          </li>
          <li className="copy">
            <a
              target="_blank"
              href={`/bt/api/r/s-g?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.demandEduc")}
            </a>
          </li>
          <li className="copy">
            <a
              target="_blank"
              href={`/bt/api/r/l-e?id=${student.student.id_student}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.educLeave")}
            </a>
          </li>
          <li className="paste">
            <a
              target="_blank"
              href={`/bt/api/r/t-t?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.trunscript")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/academ?id=${student.student.id_student}&gid=${student.student.id_group}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.acadenDemand")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/p-n?id=${student.student.id_student}&gid=${student.student.id_group}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.personInfo")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/a-e?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.archive")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/call?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.call")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/timely?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.timely")}
            </a>
          </li>
        </ul>
      </div>
      <div className="TableWrapper">
        <table>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>№</th>
              <th style={{ width: "65%", textAlign: "left" }}>
                {t("st:table.fio")}
              </th>
              <th style={{ width: "30%" }}>{t("st:table.group")}</th>
            </tr>
          </thead>
          <tbody>
            {student.students.map((item, index) => {
              if (item.id_student == active) {
                return (
                  <tr
                    className="contextenu active_line"
                    key={index}
                    onClick={() => {
                      student.newStudent(item);
                    }}
                    onContextMenu={(e) => {
                      student.newStudent(item);
                      e.preventDefault();
                      rightClick(e, item);
                    }}
                  >
                    <td>{index + 1}</td>
                    <td style={{ textAlign: "left" }}>{item.fio}</td>
                    <td>{item.p20}</td>
                  </tr>
                );
              }
              return (
                <tr
                  className="contextenu"
                  key={index}
                  onClick={() => {
                    setActive(item.id_student);
                    student.newStudent(item);
                  }}
                  onContextMenu={(e) => {
                    student.newStudent(item);
                    e.preventDefault();
                    rightClick(e, item);
                    setActive(item.id_student);
                  }}
                >
                  <td>{index + 1}</td>
                  <td style={{ textAlign: "left" }}>{item.fio}</td>
                  <td>{item.p20}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </CenterContent>
  );
});
